<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      @resetBtn="resetBtn"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:labelChangeStatus>
        <el-select
          multiple
          filterable
          v-model="filters.labelChangeStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in labelChangeStatusList"
            :label="item.text"
            :value="item.val"
            :key="item.val"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:realName>
        <el-select
          multiple
          filterable
          v-model="filters.realName"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 22,
        businessCode: currentRow.labelChangeNo,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
  </div>
</template>

<script>
import {
  getPCLabelChangeListAsync,
  exportPCLabelChangeListOut,
} from "@/api/changeLabel/LabelChange.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import { getOperatorInfo } from "@/api/api.js";
import LogDialog from "../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "labelChangeNo",
            label: "换标单据号",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
          {
            prop: "originalSKU",
            label: "SKU",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "originalProductNameCN",
            label: "SKU名称",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            label: "参考信息",
            minWidth: "200",
            formatter: function (val, row) {
              return (
                "<span>采购单号:" +
                (row.relationNo || "") +
                "</span><br /><span>新SKU:" +
                (row.newSKU || "") +
                "</span><br /> <span>新SKU名称:" +
                (row.newProductNameCN || "") +
                "</span><br /><span>规格型号:" +
                (row.model || "") +
                "</span><br />"
              );
            },
          },
          {
            prop: "labelChangeTypeText",
            label: "换标类型",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "110",
          },
          {
            prop: "labelChangeStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "quantity",
            label: "数量",
            align: "center",
            minWidth: "100",
            sortable: true,
          },

          {
            prop: "revokeQty",
            label: "撤销数量",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "operator",
            label: "操作人",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "operatorTime",
            label: "操作时间",
            align: "center",
            sortable: true,
            minWidth: "140",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "input",
            key: "originalSKU",
            label: "SKU",
            placeholder: "请输入SKU",
            clearable: true,
          },
          {
            type: "input",
            key: "newSKU",
            label: "新SKU",
            placeholder: "请输入新SKU",
            clearable: true,
          },
          {
            type: "input",
            key: "labelChangeNo",
            label: "换标单据号",
            placeholder: "请输入换标单据号",
            clearable: true,
          },
          {
            type: "select",
            key: "labelChangeStatus",
            prop: "labelChangeStatus",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.labelChangeStatusList,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------

      labelChangeStatusList: [
        {
          val: 10,
          text: "待处理",
        },
        {
          val: 20,
          text: "已处理",
        },
        {
          val: 30,
          text: "已拒绝",
        },
      ],
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },

    //查询列表
    initTable() {
      const {
        originalSKU,
        newSKU,
        labelChangeNo,
        labelChangeStatus,
        realName,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        labelChangeStatus: thereAre(labelChangeStatus),
        realName: thereAre(realName),
        originalSKU,
        newSKU,
        labelChangeNo,
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getPCLabelChangeListAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let labelChangeIDs = "";
      row.forEach((item) => {
        labelChangeIDs += item.labelChangeID + ",";
      });

      const { originalSKU, newSKU, labelChangeNo, labelChangeStatus } =
        this.newfilters;
      let pata = {
        page: 1,
        pageSize: 60001,
        labelChangeStatus: thereAre(labelChangeStatus),
        originalSKU,
        newSKU,
        labelChangeNo,
        labelChangeID: thereAre(labelChangeIDs),
      };

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportPCLabelChangeListOut,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>